import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NavView from '../views/NavView.vue'
import TreasureView from '../views/TreasureView.vue'
import ChooseListView from '../views/ChooseListView.vue'
import DetailView from '../views/DetailView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
      {
    path: '/nav',
    name: 'nav',
    component: NavView
  },
        {
    path: '/treasure',
    name: 'treasure',
    component: TreasureView
  },
          {
    path: '/choose',
    name: 'choose',
    component: ChooseListView
  },
        {
    path: '/detail',
    name: 'detail',
    component: DetailView
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
